import { BLINK_FLAGS } from '@thoughtspot/env-flags';
import { EXPERIMENT_KEY, SPARKFLOW_QUESTION_FORM_VARIANT, SPARKFLOW_USE_CASE_BASED_ONBOARDING_VARIANT, } from './experiment-variants.const';
export const experimentationConfig = {
    [EXPERIMENT_KEY.SPARKFLOW_QUESTION_FORM_VARIANT]: {
        fallbackValue: SPARKFLOW_QUESTION_FORM_VARIANT.DEFAULT,
        urlFlag: BLINK_FLAGS.formVariantValue.name,
    },
    [EXPERIMENT_KEY.SPARKFLOW_USE_CASE_BASED_ONBOARDING_VARIANT]: {
        fallbackValue: SPARKFLOW_USE_CASE_BASED_ONBOARDING_VARIANT.AGENT_SELECTION,
        urlFlag: BLINK_FLAGS.sparkflowUseCaseBasedOnboardingVariantValue.name,
    },
};
//# sourceMappingURL=experiment-keys.const.js.map